import React from 'react';
import PropTypes from 'prop-types';

import { Accordion, CurrencyInputLabel, Message } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import Style from './rateGridAccorindon.module.css';
/**
 * Component to manage Rates Accorindon
 * @param {object} event: event object to have id event
 * @param {object} rate: object rate
 * @param {number} index: index of rate in rates
 * @param {object} discountForm: discountForm object form discount
 * @param {func} handleDiscountChange: handleDiscountChange fun to set form
 */
export default function RateGridAccorindon({ event, rate, handleDiscountChange, discountForm, openByDefault }) {
    const { t } = useTranslation();
    const locale = i18n.language;
    const { rate: rateForm } = discountForm;
    const { id } = rate;

    const rateWithFees = React.useMemo(() => {
        // const _rate = rate.rate_template && !rate.price ? rate.rate_template : rate;
        const price = parseFloat(rate.getPrice());

        if (!rate.fees || !rate.fees.length) {
            return price.toFixed(2);
        }
        return rate.fees.reduce((acc, fee) => acc + parseFloat(fee.amount), price).toFixed(2);
    }, [rate]);

    const amountDiscountInvalid = React.useMemo(() => {
        // Free discounts are valid, but discount total can't be lower than 1 and higher than 0
        const discount = rateWithFees - rateForm[id]?.value;

        if (rateForm[id]?.value > rateWithFees || (discount < 1 && discount !== 0)) {
            return true;
        }
        return false;
    }, [rateWithFees, rateForm]);

    return (
        <Accordion disableToggle={false} openByDefault={openByDefault} title={rate.getName()}>
            <div className={Style['content']}>
                <CurrencyInputLabel value={rateWithFees} currency={event?.currency} locale={locale} disabled label={t('ticket.discountForm.grid.tarif_ttc')} />
                <span className={Style['symbol']}>-</span>
                <CurrencyInputLabel
                    label={t('ticket.discountForm.grid.discount')}
                    value={rateForm[id]?.value}
                    currency={event?.currency}
                    max={+rateWithFees + 0.01}
                    locale={locale}
                    onChange={({ value }) => {
                        handleDiscountChange(rate, id, value);
                    }}
                />
                <span className={Style['symbol']}>=</span>
                <CurrencyInputLabel
                    value={rateForm[id]?.value ? (+rateWithFees - +rateForm[id]?.value).toFixed(2) : ''}
                    currency={event?.currency}
                    locale={locale}
                    label={t('ticket.discountForm.grid.price_discount')}
                    disabled
                />
            </div>
            <Message title={t('ticket.discountForm.grid.error')} type="danger" visible={amountDiscountInvalid} />
        </Accordion>
    );
}

RateGridAccorindon.propTypes = {
    event: PropTypes.object.isRequired,
    rate: PropTypes.object.isRequired,
    handleDiscountChange: PropTypes.func.isRequired,
    discountForm: PropTypes.object.isRequired,
    openByDefault: PropTypes.bool
};
